<template>
    <div class="container">
        <Nav></Nav>
        <div style="width:100%; height:80px;"></div>
        <Row height="720" bg="assets/pc/service/content/p1_bg.jpg"> </Row>
        <Row height="900" bgColor="#fff">
            <div class="pos2">
                <img src="@/assets/pc/service/content/pos2_banner.jpg" />
                <h1>聚焦内容 全渠道内容生态助力营销</h1>
                <p>构建“全链路”、“跨渠道”、“多场景”、“数据化”一体的智慧内容营销生态平台，拥有自<br />有媒体、短视频及直播内容生产与制作、流量运营、汽车直播运营、红人主播培养能力以及丰富<br />KOL资源，赋能客户内容营销生态。</p>
            </div>
        </Row>
        <Footer></Footer>
    </div>
</template>
<script>
import Nav from "@/components/pc/nav.vue";
import Footer from "@/components/pc/footer.vue";
import Row from "@/components/pc/Row.vue";
export default {
    name: "pc-service-content",
    components: { Nav, Footer, Row },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
};
</script>
<style scoped>
.pos2 {
    width: 100%;
    height: 100%;
    text-align: center;
}
.pos2 p {
    font-size: 1.8rem;
    line-height: 4.5rem;
}
@media only screen and (max-width: 2048px) {
    .pos2 img {
        margin-top: 100px;
        width: calc(900px * var(--scale));
    }
    .pos2 h1 {
        font-size: 2.5rem;
        margin: 80px 0 60px 0;
    }
}

@media only screen and (min-width: 2049px) {
    .pos2 img {
        margin-top: 130px;
        width: 900px;
    }
    .pos2 h1 {
        font-size: 2.5rem;
        margin: 140px 0 80px 0;
    }
}
</style>
